import { render } from "./Toplist.vue?vue&type=template&id=fa2f6392"
import script from "./Toplist.vue?vue&type=script&lang=js"
export * from "./Toplist.vue?vue&type=script&lang=js"

import "./Toplist.vue?vue&type=style&index=0&id=fa2f6392&lang=css"

import exportComponent from "C:\\Users\\Ray Wang\\Desktop\\tubertrader\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__